
// document.addEventListener("DOMContentLoaded", function () {
//   const buttons = document.querySelectorAll(".product-tab-button");
//   const panels = document.querySelectorAll(".product-tab-panel");

//   buttons.forEach(btn => {
//     btn.addEventListener("click", () => {

//       // Remove active from all
//       buttons.forEach(b => b.classList.remove("active"));
//       panels.forEach(p => p.classList.remove("active"));

//       // Add active to clicked tab
//       btn.classList.add("active");
//       const tabID = btn.getAttribute("data-tab");
//       document.getElementById(tabID).classList.add("active");
//     });
//   });
// });

document.addEventListener("DOMContentLoaded", () => {
  const selector = ".testimonials-slider";

  function setupAutoplay(swiper) {
    // Settings
    swiper.params.autoplay = {
      delay: 3500,
      disableOnInteraction: false
    };
    swiper.params.speed = 800;
    swiper.params.loop = true;

    // Ensure autoplay is running
    if (swiper.autoplay) {
      swiper.autoplay.stop();
      swiper.autoplay.start();
    }

    // --- Desktop: Pause on hover ---
    const el = swiper.el;

    // remove previous listeners (avoid duplicates)
    el.__tPause && el.removeEventListener("mouseenter", el.__tPause);
    el.__tResume && el.removeEventListener("mouseleave", el.__tResume);

    el.__tPause = () => swiper.autoplay && swiper.autoplay.stop();
    el.__tResume = () => swiper.autoplay && swiper.autoplay.start();

    el.addEventListener("mouseenter", el.__tPause);
    el.addEventListener("mouseleave", el.__tResume);

    // --- Mobile: Pause on touch, resume after ---
    // (touch devices have no hover)
    el.__tTouchPause && el.removeEventListener("touchstart", el.__tTouchPause);
    el.__tTouchResume && el.removeEventListener("touchend", el.__tTouchResume);

    el.__tTouchPause = () => swiper.autoplay && swiper.autoplay.stop();
    el.__tTouchResume = () => {
      if (!swiper.autoplay) return;
      // kleine Verzögerung, damit es sich nicht "gegen" den Swipe anfühlt
      setTimeout(() => swiper.autoplay.start(), 1200);
    };

    el.addEventListener("touchstart", el.__tTouchPause, { passive: true });
    el.addEventListener("touchend", el.__tTouchResume, { passive: true });
  }

  function tryInit() {
    const el = document.querySelector(selector);
    if (!el) return false;

    const swiper = el.swiper;
    if (!swiper || swiper.destroyed) return false;

    setupAutoplay(swiper);
    return true;
  }

  // Immediate try
  if (tryInit()) return;

  // Retry loop (swiper may init a bit later)
  let tries = 0;
  const iv = setInterval(() => {
    tries += 1;
    if (tryInit() || tries > 40) clearInterval(iv);
  }, 200);
});